import React from 'react';

const SvgNumberOne = (props: any) => (
  <svg
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="20.5" cy="20.5" r="20" fill="#393939" />
    <path
      d="M22.5187 12.8333C21.4093 14.3693 19.5747 15.6706 18.1667 16.2039V16.4599C18.9773 16.2253 19.8947 15.8839 20.6413 15.4359V28.6199H22.604V12.8333H22.5187Z"
      fill="#F4F2EF"
    />
  </svg>
);

export default SvgNumberOne;
